import { _pHttp } from "../_pHttp";

export const getLeagues = async () => {
  const { data } = await _pHttp.get(`ticket-leagues/all`);
  return data;
};
export const getLeaguesList = async ({ page, numberInPage, search }: any) => {
  const { data } = await _pHttp.get(
    `ticket-leagues?page=${page}&numberInPage=${numberInPage}&search=${search}`
  );
  return data;
};

export async function addLeague(body: any) {
  await _pHttp.post(`/ticket-leagues`, body);
}
export async function editLeague(body: any) {
  return _pHttp.patch(`/ticket-leagues/${body.id}`, body);
}
export async function deleteLeague(id: any) {
  return _pHttp.delete(`/ticket-leagues/${id}`);
}
